<template>
  <OmtLayoutContainer
    v-if="program"
    class="hub-how"
  >
    <OmtRow :display="['none', 'flex']">
      <HubBreadcrumb :items="breadcrumb" />
    </OmtRow>
    <OmtRow>
      <OmtTypography as="h1-bold">Como o programa funciona</OmtTypography>
    </OmtRow>
    <OmtRow mt="16px">
      <ol class="hub-how__steps">
        <li
          v-for="(step, index) in program.howItWorks"
          :key="step.title"
          class="hub-how__item"
        >
          <span class="hub-how__badge">{{ index + 1 }}.</span>
          <div>
            <OmtTypography as="h2-bold">{{ step.title }}</OmtTypography>
            <OmtTypography
              as="p1"
              mt="4px"
              color="var(--colors-light-primary-gray1)"
              >{{ step.text }}</OmtTypography
            >
          </div>
        </li>
      </ol>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import HubBreadcrumb from "@/components/Organisms/HubSaude/HubBreadcrumb.vue";
import { getHubProgramBySlug } from "@/data/hubSaude";

export default {
  name: "HubSaudeComoFunciona",
  components: { HubBreadcrumb },
  computed: {
    program() {
      return getHubProgramBySlug(this.$route.params.slug);
    },
    breadcrumb() {
      return [
        { label: "Home", to: "/" },
        { label: "Hub de saúde", to: "/hub-de-saude" },
        { label: "Programas de saúde", to: "/hub-de-saude/programas" },
        { label: this.program?.title || "Programa", to: `/hub-de-saude/programas/${this.$route.params.slug}` },
        { label: "Como o programa funciona" }
      ];
    }
  },
  created() {
    if (!this.program?.howItWorks?.length) {
      this.$router.replace({ name: "hub_saude.programas" });
      return;
    }
    this.$root.$emit("change-back-route", `/hub-de-saude/programas/${this.program.slug}`);
  }
};
</script>

<style scoped>
.hub-how {
  width: 100%;
}

.hub-how__steps {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.hub-how__item {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.hub-how__badge {
  flex-shrink: 0;
  color: var(--colors-light-primary-navy-blue);
  font-weight: 700;
}
</style>
